module.exports = __webpack_public_path__ + "static/media/Catalogo Productos  Metecno.eb0aebfe.pdf";